/**
 * Call one typed hub endpoint (`endpoints.ts` key) through the track's
 * hub-proxy generic dispatcher (`POST ${proxyBaseUrl}/call` with
 * `{ endpoint, args }`). The proxy injects the hub API key server-side, so
 * the browser never holds it. Non-2xx rejects.
 */
export async function callViaProxy(proxyBaseUrl, endpoint, getAuthHeaders, args) {
    const auth = (await getAuthHeaders?.()) ?? {};
    const url = proxyBaseUrl.replace(/\/+$/, '') + '/call';
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'content-type': 'application/json', ...auth },
        body: JSON.stringify({ endpoint, args }),
    });
    if (!res.ok) {
        throw new Error(`${endpoint} via proxy failed: ${res.status} ${res.statusText}`);
    }
    return (await res.json());
}
//# sourceMappingURL=call-via-proxy.js.map